import { render } from "./PrivacyPolicyScreen.vue?vue&type=template&id=1a26f22a&scoped=true"
import script from "./PrivacyPolicyScreen.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyScreen.vue?vue&type=script&lang=js"

import "./PrivacyPolicyScreen.vue?vue&type=style&index=0&id=1a26f22a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a26f22a"]])

export default __exports__